<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/123OvHH/tc-custom/9780545841023.jpg?1729379531600" alt="This image is the cover for the book Trapped in Bat Wing Hall, Give Yourself Goosebumps"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Trapped in Bat Wing Hall, Give Yourself Goosebumps
      </h1>
      <p class="bookDescription body article font2">
        <b>Choose your fate on a wild scavenger hunt in this scary GOOSEBUMPS adventure that’s packed with more than twenty super-spooky endings.</b><br/><br/>Being the new kid in school is no picnic. At your old school you had tons of friends, but now you don’t even have one. Then you meet Nick. He asks you to join Horror Club. The Horror Club meets in an old mansion known as Bat Wing Hall. It’s dark. It’s spooky. And it’s where your adventure begins. <br/><br/>The members of the Horror Club are going on a scavenger hunt. If you join the red team, you find out the truth about your new friends—they’re actually monsters! One is a green-skinned reptile. Another is a hulking giant! If you join the blue team, you get turned into a furry-faced vampire bat! The choice is yours . . . <br/><br/><b>Reader beware—you choose the scare! GIVE YOURSELF GOOSEBUMPS!</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R.L. Stine
      </h2>
      
      <p class="authorDescription body article"> R.L. Stine is the creator of the bestselling Goosebumps series, which has more than 400 million copies in print worldwide and celebrated 25 years in 2017. Goosebumps is one of the bestselling children's series of all-time and inspired a popular television show, as well as a feature film starring Jack Black that opened at #1 at the box office. His other popular children's books include the series Fear Street, Mostly Ghostly, The Nightmare Room, and Rotten School, and his  picture books, with Marc Brown, <I>The Little Shop of Monsters</I> and <I>Mary McScary</I>. R.L. Stine lives in New York City. You can connect with him on Twitter at @RL_Stine or Facebook: facebook.com/rlstine. For more information, visit rlstine.com and scholastic.com/goosebumps. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Scholastic
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a675a86